import { Box, Button, DialogTitle, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
} from '~/components/ui/dialog';

import { useI18nLn } from '~/hooks/store';

type Props = {
  onSubmitAlert: () => void;
  onCancelAlert: () => void;
  isOpen: boolean;
};
export const NoDeliveryAlertModal: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();

  const onClose = props.onCancelAlert;
  const onRegister = props.onSubmitAlert;

  return (
    <DialogRoot open={props.isOpen} onInteractOutside={onClose}>
      <Flex
        flexDir="row"
        p="16px"
        justify="left"
        alignItems="center"
        rounded="10px"
      >
        <DialogBackdrop />
        <DialogContent
          mx={2}
          my={0}
          alignSelf="center"
          p="16px"
          maxW={{ base: '90%', sm: '400px' }}
        >
          <DialogHeader px="50px">
            <DialogTitle>
              {t('pages.buy.shippings.no.confirm_title')}
            </DialogTitle>
          </DialogHeader>
          <DialogCloseTrigger onClick={onClose} />
          <Flex flex={1} flexDir="column" justifyContent="center" mx={2}>
            <DialogBody>
              <Text color="black" fontWeight="thin" fontSize="sm" px="16px">
                {t('pages.buy.shippings.no.confirm_description')}
              </Text>
              <Box h="24px" />
              <Flex
                flexDir="column"
                p="16px"
                justify="center"
                alignItems="center"
              >
                <Button
                  type="submit"
                  h="40px"
                  w="full"
                  borderRadius="20px"
                  fontSize="14px"
                  fontWeight="bold"
                  variant="outline"
                  color="white"
                  bgColor="primary"
                  onClick={onRegister}
                >
                  {t('global.common.ok')}
                </Button>
                <Box h="16px" />
                <Button
                  type="submit"
                  h="40px"
                  w="full"
                  borderRadius="20px"
                  fontSize="14px"
                  fontWeight="bold"
                  colorPalette="link"
                  variant="outline"
                  onClick={props.onCancelAlert}
                >
                  {t('global.common.cancel')}
                </Button>
              </Flex>
            </DialogBody>
          </Flex>
        </DialogContent>
      </Flex>
    </DialogRoot>
  );
};
